<template>
  <div class="row d-flex">
    <div class="col-12 col-md-6 mt-4">
      <div class="card">
        <div class="card-body">
          <div class="card-text text-start">
            <p><strong>CPF:</strong> {{ formData.cpf }}</p>
            <p><strong>Voucher:</strong> {{ getSolicitation.voucher }}</p>
            <p>
              <strong>Certificado adquirido:</strong>
              {{ getProduto.nome || ' - ' }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 mt-4">
      <div class="card">
        <div class="card-body">
          <div class="card-text text-start">
            <p v-for="field in fieldsWithValuesWithoutCpf" :key="field.id">
              <strong>{{ field.label }}: </strong>
              {{ field.value }}
            </p>
          </div>
          <div class="card-title d-flex text-start justify-content-end">
            <router-link
              class="btn btn-sm btn-outline-info"
              type="button"
              to="form"
            >
              <Icon name="pen-to-square" class="me-2" />
              <span>Editar</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { mapState } from 'pinia'
  import {
    useDynamicForms,
    FieldInfoType,
  } from '@/store/Pinia/useDynamicForms.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'

  export default defineComponent({
    name: 'DynamicSummaryComponent',
    components: {
      Icon,
    },
    computed: {
      ...mapState(useDynamicForms, ['formData', 'formInfo']),
      ...mapState(useSolicitation, ['getSolicitation', 'getProduto']),
      fieldsWithValuesWithoutCpf() {
        const fields = this.formInfo as FieldInfoType[]
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data = this.formData as any

        return (
          fields
            .map((field: FieldInfoType) => ({
              ...field,
              value: data[field.id as keyof typeof data],
            }))
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .filter((field: any) => field.value && field.id !== 'cpf')
        )
      },
    },
  })
</script>
